/**
 * @desc 列表+明细
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.ProductMasterResponseDto>>;
export function request(
  body: defs.basics.ProductMasterRequestParamsDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/productMaster/list/details`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
